module.exports = __webpack_public_path__ + "img/full5-min.51a0ac98.png";